import { render, staticRenderFns } from "./fieldtype_radio.vue?vue&type=template&id=6ba51642&"
import script from "./fieldtype_radio.vue?vue&type=script&lang=js&"
export * from "./fieldtype_radio.vue?vue&type=script&lang=js&"
import style0 from "./fieldtype_radio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports